<template>
  <div id="app">
    <SiteHeader />
    <div class="page-component__scroll">
      <el-scrollbar class="app-page-scrollbar">
        <main class="app-main">
          <router-view />
        </main>
        <Footer />
      </el-scrollbar>
    </div>
    <el-backtop target=".page-component__scroll .el-scrollbar__wrap" />
    <div
      v-show="routeBarActive"
      class="app-route-progress"
      aria-hidden="true"
    />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import Footer from '@/components/footer.vue'
import { routeProgressState } from '@/utils/routeProgress'

export default {
  name: 'App',
  components: { SiteHeader, Footer },
  computed: {
    routeBarActive() {
      return routeProgressState.active
    },
  },
  watch: {
    '$i18n.locale'() {
      this.applyDocumentLangAndTitle()
    },
  },
  mounted() {
    this.applyDocumentLangAndTitle()
  },
  methods: {
    applyDocumentLangAndTitle() {
      document.title = this.$t('site.documentTitle')
      const langMap = { 'zh-CN': 'zh-CN', en: 'en', ja: 'ja' }
      document.documentElement.setAttribute('lang', langMap[this.$i18n.locale] || 'zh-CN')
    },
  },
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
    "Liberation Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 88px;
}

.page-component__scroll {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.app-page-scrollbar {
  height: 100%;
}

.app-main {
  flex: 1 0 auto;
}

/* 路由进度条：固定在最顶层，避免被顶栏/滚动区盖住 */
.app-route-progress {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  z-index: 2147483646;
  pointer-events: none;
  background: linear-gradient(90deg, #1d4ed8 0%, #2563eb 40%, #0ea5e9 100%);
  box-shadow:
    0 3px 14px rgba(37, 99, 235, 0.65),
    0 1px 0 rgba(255, 255, 255, 0.35) inset;
}

.app-route-progress::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.55) 50%,
    transparent 100%
  );
  background-size: 50% 100%;
  background-repeat: no-repeat;
  animation: app-route-progress-shine 0.85s linear infinite;
}

@keyframes app-route-progress-shine {
  0% {
    background-position: -50% 0;
  }
  100% {
    background-position: 150% 0;
  }
}

</style>
